<template>
  <div>
    <ModalContainer
      v-if="create"
      popup
      :title="title"
      :video-modal="videoModal"
      rounded="rounded-xl"
      @toggle="$emit('toggle')"
      @on-back-button="$emit('on-back-button')"
    >
      <AlertModal
        :body="body"
        :type="type"
        :redirect-url="redirectUrl"
        :show-confirm-button="showConfirmButton"
        :user-type="userType"
        :disable-agree-button="disableAgreeButton"
        @toggle="$emit('toggle')"
        @clicked="$emit('clicked', $event)"
        @agree="$emit('agree', $event)"
      >
        <template
          v-if="$slots.message - input"
          #message
        >
          <slot name="message-input" />
        </template>
        <template #agree>
          <slot name="agree" />
        </template>
      </AlertModal>
    </ModalContainer>
  </div>
</template>

<script>

import AlertModal from './_components/AlertModal'
import ModalContainer from '@/modules/modal'

export default {
  name: 'AlertModalModule',
  components: {
    AlertModal,
    ModalContainer
  },
  props: {
    create: { type: Boolean, default: false },
    title: { type: String, default: '' },
    body: { type: String, default: '' },
    type: { type: String, default: '' },
    showConfirmButton: { type: Boolean, default: false },
    disableAgreeButton: { type: Boolean, default: false },
    userType: { type: Boolean, default: false },
    videoModal:{ type: Boolean, default: false },
    logo: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'toggle',
    'clicked',
    'on-back-button',
    'agree'
  ],
  computed: {
    redirectUrl() {
      return process.env.VUE_APP_HS_URL + `/for-companies`
    }
  }
}
</script>
